"use client";

import React from "react";
import { NavigateButton } from "../NavigateButton";
import { StyledLink } from "../StyledLink";
import { LookalikeLink } from "../StyledLink/lookalikeLink";
import { useIsWebview } from "../WebviewContext/hooks";

type Props = {
    children: React.ReactNode;
    link: string;
    isSnow: boolean;
    isActive: boolean;
    title: string;
};

export const LinkWrapper: React.FC<Props> = ({
    children,
    link,
    isSnow,
    isActive,
    title,
}) => {
    const isWebview = useIsWebview();

    if (isWebview) {
        return (
            <LookalikeLink
                type={
                    isSnow
                        ? "snowPrimary"
                        : isActive
                          ? "weatherSecondary"
                          : "weatherTertiary"
                }
                fullWidth
            >
                <NavigateButton url={link}>{children}</NavigateButton>
            </LookalikeLink>
        );
    }

    return (
        <StyledLink
            href={link}
            type={
                isSnow
                    ? "snowPrimary"
                    : isActive
                      ? "weatherSecondary"
                      : "weatherTertiary"
            }
            linkType="anchor"
            title={title}
            aria-label={title}
            data-label="Zum_animierten_Niederschlagsradar"
            fullWidth
        >
            {children}
        </StyledLink>
    );
};
